module.exports = __webpack_public_path__ + "img/excel.616b685e.svg";